// extracted by mini-css-extract-plugin
export default {"Title":"title_Title__c9ncJ","FootballSpider":"title_FootballSpider__wjJSt"};